import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useOnboarding } from '../../../../context/OnboardingContext';
import { PrivateWizardLayout, WizardContainer, WizardCard, WizardActions } from '../../WizardLayout';
import Stepper from '../../Stepper';
import { toast } from 'react-toast';
import '../../../../styles/wizard.css';
import Step9IotModal from '../../modals/Step9IOTModal/Step9IotModal';
import { useGetIOTTestCases } from '../../../../hooks/API/wizard.api';
import CreateNewTestCaseModal from '../../modals/NewTestCaseModal';

const Step9IotCreateTest = () => {
  const navigate = useNavigate();
  const { iot, setIot, nextStep, previousStep ,markStepCompleted,goToStep , data} = useOnboarding();
  const projectId = data?.project?.project_id
 

  
  const [creationMethod, setCreationMethod] = useState('record'); // 'ai' or 'record'
  const [isRecording, setIsRecording] = useState(
  () => !!(
    (iot.testCaseIds && iot.testCaseIds.length > 0) ||
    (iot.steps && iot.steps.length > 0)
  )
);

 const {data: iotTestCases, isLoading: isTestCasesLoading} = useGetIOTTestCases({projectId ,  enabled: isRecording });

  const [testCase, setTestCase] = useState({
    name: '',
    description: '',
     priority: 'low'
  });
  const [showModal, setShowModal] = useState(false);
  const [openCards, setOpenCards] = useState({});
  const [newTestModal , setNewTestModal]= useState(false);

const handleOpenModal = () => {
  if (!testCase.name.trim()) {
    toast.error('Please enter a test case name');
    return;
  }
  setShowModal(true);
};

useEffect(() => {
  if (iot.testCaseIds?.length > 0 || iot.steps?.length > 0) {
    setIsRecording(true);
  }
}, [iot.testCaseIds, iot.steps]);

const handleStartRecording = async () => {
  setIsRecording(true);
};


  const handleGenerateFromAI = () => {
    // Simulate AI generation
    const generatedTestCaseId = `tc_ai_${Date.now()}`;
    const newTestCaseIds = [...(iot.testCaseIds || []), generatedTestCaseId];
    
    setIot({
      ...iot,
      testCaseIds: newTestCaseIds
    });
    
    toast.success('Test case generated from requirements!');
  };

  const handleContinue = () => {
    if (!iot.testCaseIds || iot.testCaseIds.length === 0) {
      toast.error('Please create at least one test case');
      return;
    }

    markStepCompleted(9);
    goToStep(10);
    navigate('/app/onboarding?step=10');
  };

  const toggleCard = (id) => {
  setOpenCards(prev => ({ ...prev, [id]: !prev[id] }));
};

  function handleNewTestModal(){
     setShowModal(true)
     setNewTestModal(false);
  }

  return (
    <PrivateWizardLayout>
      <WizardContainer>
        <Stepper currentStep={9} completedSteps={[1, 2, 3, 4, 5, 6, 7, 8]} />
        
        <WizardCard
          title="Create your first Hardware Test Case"
          subtitle="Generate tests using AI or record hardware interactions"
        >
          {/* Creation method selection */}
          {!isRecording && (!iot.testCaseIds || iot.testCaseIds.length === 0) && (
            <div style={{ marginBottom: '2rem' }}>
              <label className="wizard-form-label">Test Creation Method</label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem' }}>
                <button
                  onClick={() => setCreationMethod('record')}
                  className={`wizard-btn ${creationMethod === 'record' ? 'wizard-btn-primary' : 'wizard-btn-secondary'}`}
                  style={{ 
                    padding: '1.5rem',
                    height: 'auto',
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                  }}
                >
                  <div style={{ fontSize: '1.5rem' }}>🎥</div>
                  <strong>Record Hardware Flow</strong>
                  <small style={{ opacity: 0.8 }}>Recommended</small>
                </button>

                <button
                  onClick={() => setCreationMethod('ai')}
                  className={`wizard-btn ${creationMethod === 'ai' ? 'wizard-btn-primary' : 'wizard-btn-secondary'}`}
                  style={{ 
                    padding: '1.5rem',
                    height: 'auto',
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                  }}
                >
                  <div style={{ fontSize: '1.5rem' }}>✨</div>
                  <strong>AI Generate</strong>
                  <small style={{ opacity: 0.8 }}>From requirements</small>
                </button>
              </div>
            </div>
          )}

          {/* Record method */}
          {creationMethod === 'record' && !isRecording && (!iot.testCaseIds || iot.testCaseIds.length === 0) && (
            <div>
              <div className="wizard-form-group">
                <label className="wizard-form-label">
                  Test Case Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  className="wizard-form-input"
                  value={testCase.name}
                  onChange={(e) => setTestCase({ ...testCase, name: e.target.value })}
                  placeholder="e.g., Unlock and verify status"
                />
              </div>

              <div className="wizard-form-group">
                <label className="wizard-form-label">Description</label>
                <textarea
                  className="wizard-form-input"
                  value={testCase.description}
                  onChange={(e) => setTestCase({ ...testCase, description: e.target.value })}
                  placeholder="Describe what this test validates..."
                  rows={3}
                />
              </div>

              <div className="wizard-form-group">
                <label className="wizard-form-label">Priority</label>
                <select
                  className="wizard-form-input"
                  value={testCase.priority}
                  onChange={(e) => setTestCase({ ...testCase, priority: e.target.value })}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>

              <button
                onClick={handleOpenModal}
                className="wizard-btn wizard-btn-primary"
                style={{ width: '100%', marginTop: '1rem' }}
                disabled={!testCase.name.trim()}
              >
                🔴 Start Recording
              </button>
            </div>
          )}

          {/* AI method */}
          {creationMethod === 'ai' && (!iot.testCaseIds || iot.testCaseIds.length === 0) && (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✨</div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                AI Test Generation
              </h3>
              <p style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
                Generate test cases automatically from your requirements
              </p>
              <button
                onClick={handleGenerateFromAI}
                className="wizard-btn wizard-btn-primary"
              >
                Generate Test Cases
              </button>
            </div>
          )}

          {/* Recording in progress */}
        {isRecording && (
          <div>
            {isTestCasesLoading ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-secondary)' }}>
                Loading test cases...
              </div>
            ) : (
              <div style={{ display: 'grid', gap: '1.25rem' }}>
                {(iotTestCases?.data || []).map((tc, idx) => {
                  const steps = tc.steps?.step_description || [];
                  const isOpen = openCards[tc.test_case_id] ?? false; // first card open by default
                  const priorityConfig = {
                    low:    { bg: '#f0fdf4', color: '#15803d', border: '#bbf7d0', dot: '#22c55e', label: 'Low Priority' },
                    medium: { bg: '#fffbeb', color: '#b45309', border: '#fde68a', dot: '#f59e0b', label: 'Medium Priority' },
                    high:   { bg: '#fef2f2', color: '#dc2626', border: '#fecaca', dot: '#ef4444', label: 'High Priority' },
                  };
                  const cfg = priorityConfig[tc.priority] || priorityConfig.low;

                  return (
                    <div key={tc.test_case_id} style={{
                      border: '1px solid #e2e8f0',
                      borderRadius: '14px',
                      overflow: 'hidden',
                      background: 'white',
                    }}>
                      {/* Clickable Header */}
                      <div
                        onClick={() => toggleCard(tc.test_case_id)}
                        style={{
                          padding: '1rem 1.25rem',
                          borderBottom: isOpen ? '1px solid #f1f5f9' : 'none',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          background: '#fafafa',
                          cursor: 'pointer',
                          userSelect: 'none',
                          transition: 'background 0.15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
                        onMouseLeave={e => e.currentTarget.style.background = '#fafafa'}
                      >
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span>🧪</span>
                            <span style={{ fontSize: '0.925rem', fontWeight: '700', color: '#0f172a' }}>{tc.name}</span>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', gap: '4px',
                              fontSize: '0.7rem', fontWeight: '600',
                              background: cfg.bg, color: cfg.color,
                              border: `1px solid ${cfg.border}`,
                              borderRadius: '20px', padding: '2px 8px',
                            }}>
                              <span style={{ width: 5, height: 5, borderRadius: '50%', background: cfg.dot, display: 'inline-block' }} />
                              {cfg.label}
                            </span>
                            {tc.description && (
                              <>
                                <span style={{ width: 3, height: 3, borderRadius: '50%', background: '#cbd5e1', display: 'inline-block' }} />
                                <span style={{ fontSize: '0.7rem', color: '#94a3b8' }}>{tc.description}</span>
                              </>
                            )}
                          </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                          {/* Step count pill */}
                          <div style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center',
                            background: 'linear-gradient(135deg, #eff6ff, #f5f3ff)',
                            border: '1px solid #ddd6fe',
                            borderRadius: '10px',
                            padding: '0.4rem 0.75rem',
                            minWidth: '52px',
                          }}>
                            <span style={{ fontSize: '1.2rem', fontWeight: '800', color: '#4f46e5', lineHeight: 1 }}>
                              {steps.length}
                            </span>
                            <span style={{ fontSize: '0.6rem', color: '#6366f1', fontWeight: '600', marginTop: '2px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                              Steps
                            </span>
                          </div>

                          {/* Chevron */}
                          <svg
                            width="16" height="16" viewBox="0 0 24 24"
                            fill="none" stroke="#94a3b8" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round"
                            style={{ transition: 'transform 0.25s cubic-bezier(0.4,0,0.2,1)', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}
                          >
                            <polyline points="6 9 12 15 18 9" />
                          </svg>
                        </div>
                      </div>

                      {/* Collapsible Steps body */}
                      <div style={{
                        display: 'grid',
                        gap: '0.5rem',
                        overflow: 'hidden',
                        maxHeight: isOpen ? '2000px' : '0px',
                        padding: isOpen ? '0.875rem 1.25rem' : '0 1.25rem',
                        transition: 'max-height 0.35s cubic-bezier(0.4,0,0.2,1), padding 0.35s cubic-bezier(0.4,0,0.2,1)',
                      }}>
                        {steps.map((step) => (
                          step.is_physical ? (
                            <div key={step.step_number} style={{
                              padding: '0.75rem 0.875rem',
                              border: '1px solid #ede9fe',
                              borderRadius: '8px',
                              background: '#faf5ff',
                              fontSize: '0.875rem',
                            }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                  <span style={{
                                    width: '20px', height: '20px', borderRadius: '50%',
                                    background: '#8B5CF6', color: 'white',
                                    fontSize: '0.65rem', fontWeight: '700',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                  }}>{step.step_number}</span>
                                  <strong style={{ color: '#5b21b6' }}>🦾 Physical Arm Move</strong>
                                </div>
                                <span style={{
                                  fontSize: '0.68rem', background: '#f5f3ff', color: '#7c3aed',
                                  border: '1px solid #ddd6fe', borderRadius: '20px', padding: '2px 8px',
                                }}>⏱ {step.interval}ms</span>
                              </div>
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.3rem' }}>
                                {Object.entries(step.joint_values).map(([joint, val]) => (
                                  <div key={joint} style={{
                                    background: 'white', borderRadius: '6px',
                                    padding: '0.3rem 0.5rem', fontSize: '0.72rem',
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    border: '1px solid #ede9fe',
                                  }}>
                                    <span style={{ color: '#7c3aed', textTransform: 'capitalize' }}>
                                      {joint.replace('_', ' ')}
                                    </span>
                                    <strong style={{ color: '#5b21b6' }}>{val}°</strong>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div key={step.step_number} style={{
                              padding: '0.75rem 0.875rem',
                              border: '1px solid #a5f3fc',
                              borderRadius: '8px',
                              background: '#ecfeff',
                              fontSize: '0.875rem',
                            }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                  <span style={{
                                    width: '20px', height: '20px', borderRadius: '50%',
                                    background: '#06B6D4', color: 'white',
                                    fontSize: '0.65rem', fontWeight: '700',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                  }}>{step.step_number}</span>
                                  <strong style={{ color: '#0e7490' }}>📡 Service Step</strong>
                                </div>
                                <span style={{
                                  fontSize: '0.68rem', background: 'white', color: '#0e7490',
                                  border: '1px solid #a5f3fc', borderRadius: '20px', padding: '2px 8px',
                                }}>⏱ {step.interval}ms</span>
                              </div>
                              <div style={{ display: 'grid', gap: '0.2rem', marginBottom: '0.5rem' }}>
                                {[
                                  { label: 'Service UUID', value: step.service_uuid },
                                  { label: 'Char UUID', value: step.char_uuid },
                                ].map(row => (
                                  <div key={row.label} style={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    fontSize: '0.72rem', padding: '0.2rem 0',
                                    borderBottom: '1px solid #cffafe',
                                  }}>
                                    <span style={{ color: '#0e7490' }}>{row.label}</span>
                                    <span style={{ fontFamily: 'monospace', color: '#0f172a', fontWeight: 500, fontSize: '0.68rem' }}>
                                      {row.value}
                                    </span>
                                  </div>
                                ))}
                              </div>
                              <div style={{ display: 'flex', gap: '0.375rem', flexWrap: 'wrap' }}>
                                {[
                                  { label: 'Read', value: step.can_read },
                                  { label: 'Write', value: step.can_write },
                                  { label: 'Notify', value: step.can_notify },
                                ].map(cap => (
                                  <span key={cap.label} style={{
                                    fontSize: '0.68rem',
                                    background: cap.value ? '#f0fdf4' : 'white',
                                    color: cap.value ? '#16a34a' : '#94a3b8',
                                    border: `1px solid ${cap.value ? '#bbf7d0' : '#e2e8f0'}`,
                                    borderRadius: '20px', padding: '2px 8px', fontWeight: 600,
                                  }}>
                                    {cap.value ? '✓' : '✗'} {cap.label}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )
                        ))}
                      </div>
                    </div>
                  );
                })}

            {iotTestCases?.data?.length > 0  &&   <button
            onClick={() => setNewTestModal(true)}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-blue-500 hover:bg-blue-600 active:scale-95 text-white text-sm font-semibold rounded-xl border-none cursor-pointer shadow-md shadow-blue-200 transition-all duration-150"
          >
            Record New Test Case

          </button>}

              </div>
            )}
          </div>
        )}

          <WizardActions
            showBack={true}
            onBack={() => {
              // Clean up recording if active
              if (isRecording && window.iotRecordingInterval) {
                clearInterval(window.iotRecordingInterval);
              }
              previousStep();
              navigate('/app/onboarding?step=8');
            }}
            showNext={true}
            onNext={handleContinue}
            nextLabel="Continue"
            nextDisabled={!iot.testCaseIds || iot.testCaseIds.length === 0}
          />
        </WizardCard>
      </WizardContainer>


   {showModal && (
    <Step9IotModal 
        onClose={()=> {setShowModal(false)}}
         onSave={() => {
          handleStartRecording();
          setTestCase({ name: '', description: '', priority: 'low' }); 
        }}
        projectId={projectId}
          onCancel={() => {
        setShowModal(false);
        setTestCase({ name: '', description: '', priority: 'low' }); 
      }}
        testCase={testCase}
        initialSteps={iot.steps || []}
        />
   )}

    {newTestModal && (
      <CreateNewTestCaseModal 
        onClose={()=> setNewTestModal(false)}
        onSave={handleNewTestModal}
        testCase={testCase}      
        setTestCase={setTestCase} 
      />
    )}

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }
      `}</style>
    </PrivateWizardLayout>
  );
};

export default Step9IotCreateTest;